import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { urlPath } from 'src/utils/lpPath'

const ContactComplete: React.FC = () => {
  return (
    <>
      <main>
        <div className="contact">
          <div id="contactNavbarPC" className="flex justify-between sp:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="120"
                  height="55"
                  layout="raw"
                />
              </a>
            </Link>
          </div>
          <div id="contactNavbarSP" className="flex justify-between pc:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="105"
                  height="48"
                  layout="raw"
                />
              </a>
            </Link>
          </div>
          <div className="body">
            <div className="section text-center">
              <div className="faqCaption mb-16">
                <p className="caption">お問い合わせ</p>
              </div>
              <p className="mb-8 text-lg font-bold">お問い合わせを受付いたしました。</p>
              <p className="mb-8">管理者がお問い合わせ内容を確認いたします。</p>
              <p className="mb-8">
                後日、ご入力いただいたメールアドレス宛に回答させていただきますので、しばらくお時間を頂戴したく存じます。
              </p>
              <Link href={urlPath.top}>
                <a className="toTop">トップへ戻る</a>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
export default ContactComplete
